import Swal from "sweetalert2";
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import { ResolutionLabels } from '../../../../../Enums';
import withReactContent from "sweetalert2-react-content";
import renderSelectField from '@/shared/components/form/Select';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const EditCropRequestPrice = (props) => {
    const [collectionsList, setCollectionsList] = useState();
    const [cropRequestPrice, setCropRequestPrice] = useState();

    useEffect(() => {
        AdminInterface.instance.getCollections().then((response) => {
            setCollectionsList(response.data)
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        });
    }, [])

    useEffect(() => {
        if (!collectionsList) return;

        setCropRequestPrice({
            collection_id: { label: props.cropRequestPrice.collection.name, value: props.cropRequestPrice.collection_id },
            resolution: { label: ResolutionLabels[props.cropRequestPrice.resolution], value: props.cropRequestPrice.resolution },
            oldAssetPrice: props.cropRequestPrice.oldAssetPrice,
            newAssetPrice: props.cropRequestPrice.newAssetPrice
        })
    }, [collectionsList, props.cropRequestPrice]);

    const submitCropRequestPrice = (values) => {
        values.collection_id = values.collection_id.value;
        values.resolution = values.resolution.value;
        AdminInterface.instance.updateCropRequestPrice(values).then(() => {
            withReactContent(Swal).fire({
                title: "Success",
                html: "Crop request price is updated!",
            });
            props.setEditCropRequestPrice({ collection: null, resolution: null });
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        });
    }

    return (
        <Col md={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Edit Crop Request Price</CardTitle>
                    </CardTitleWrap>
                    {collectionsList && <Form onSubmit={submitCropRequestPrice} initialValues={cropRequestPrice}>
                        {({ handleSubmit, form }) => (
                            <FormContainer horizontal onSubmit={handleSubmit}>
                                <FormGroup>
                                    <FormGroupLabel>Collection</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="collection_id" component={renderSelectField}
                                            options={Object.keys(collectionsList).map(function (collection) {
                                                return { value: collectionsList[collection].id, label: collectionsList[collection].name }
                                            })}
                                        />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Resolution</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="resolution" component={renderSelectField}
                                            options={Object.keys(ResolutionLabels).map(function (key) {
                                                return { value: key, label: ResolutionLabels[key] }
                                            })}
                                        />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Old Assets Price (CAD ¢/KM2)</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="oldAssetPrice" component="input" type="text" placeholder="25000" />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>New Assets Price (CAD ¢/KM2)</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="newAssetPrice" component="input" type="text" placeholder="25000" />
                                    </FormGroupField>
                                </FormGroup>
                                <FormButtonToolbar>
                                    <Button variant="primary" type="submit">Submit</Button>
                                    <Button variant="secondary" type="button" onClick={() => props.setEditCropRequestPrice({ collection: null, resolution: null })}>
                                        Cancel
                                    </Button>
                                </FormButtonToolbar>
                            </FormContainer>
                        )}
                    </Form>}
                </CardBody>
            </Card>
        </Col>
    );
};

EditCropRequestPrice.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default EditCropRequestPrice;